import React, { useState } from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { FiUserPlus } from 'react-icons/fi';
import { ExternalLink } from './components/ExternalLink';
import { CC_LOGO_SMALL } from './config/images';
import { InviteOverlay } from './InviteOverlay';
import './Header.scss';

const profileUrl = (user) => {
  const username = user.startsWith('guest-') ? 'guest' : user;
  return `https://images.hive.blog/u/${username}/avatar`;
}

export const Header = ({ loggedInUser, handleDisconnect, joinMyInviteLink }) => {
  const [showInviteModal, setShowInviteModal] = useState(false);

  const toggleInviteModal = () => {
    setShowInviteModal((prevState) => !prevState);
  };

  return (
    <div className="header">
      <div className="left-section">
        <img src={CC_LOGO_SMALL} alt="Crypto Chess" className="game-logo" />
        <button className="invite-button icon" onClick={toggleInviteModal}>
          <FiUserPlus />
        </button>

        {/* Pass only the necessary props */}
        <InviteOverlay
          loggedInUser={loggedInUser}
          joinMyInviteLink={joinMyInviteLink}
          showInviteModal={showInviteModal}
          toggleInviteModal={toggleInviteModal}
        />
      </div>

      <div className="user-group">
        <div
          className="user-pic"
          style={{
            backgroundImage: `url(${profileUrl(loggedInUser)})`,
          }}
        ></div>
        <span className="username">
          <ExternalLink href={`https://peakd.com/@${loggedInUser}`}>{loggedInUser}</ExternalLink>
        </span>
        <button className="logout-button icon" onClick={handleDisconnect}>
          <FaSignOutAlt />
        </button>
      </div>
    </div>
  );
};
